<template>
  <ModalDialog
    ref="dialog"
    title="Purchase New Subscription"
    icon="fa-shopping-cart"
    sizeClass="modal-xl"
    :showSubmit="false"
    :showFooter="false"
    :scrollable="true"
    @closed="onClosed">

    <BillingProductList
      purchaseButtonTitle="Checkout"
      :displayAddonProducts="displayAddonProducts"
      :submittingPurchaseProductId="submittingPurchaseProductId"
      @purchaseClicked="checkoutProduct"
      @contactClicked="contactClicked"
    />
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import BillingProductList from '@/modules/admin/components/billingProductList'
import ProcessingDialog from '@/components/dialog/processingDialog.vue'

export default {
  name: 'BillingProductListDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    BillingProductList
  },
  props: {
    displayAddonProducts: Boolean
  },
  data() {
    return {
      submittingPurchaseProductId: 0
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    checkoutProduct(purchaseInfo) {
      this.submittingPurchaseProductId = purchaseInfo.id

      // Redirect to billing to finalise the payment
      this.$apiService.adminService.createBillingCheckoutSession({
        stripePriceLineItems: purchaseInfo.priceLineItems,
        isBillingPage: true
      })
      .then(response => {
          setTimeout(() => {
            window.location.href = response.data.url
          }, 1000)
      })
      .catch(err => {
        this.submittingPurchaseProductId = 0
        this.displayNetworkError(err, 'Failed to connect', 'Error while attempting to connect to billing system')
      })
    },
    contactClicked(purchaseInfo) {
      window.location.href = `mailto:sales@synsoft.com.au?subject=Purchasing Subscription ${purchaseInfo.name}`

    }
  }
}
</script>